import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const LightBulbIcon = memo(({ fontSize }: SvgIconProps) => {
  return (
    <SvgIcon width="56" height="47" viewBox="0 0 56 47" fill="none" style={{ fontSize }}>
      <svg fill="none">
        <path
          d="M30.8996 2.63653C23.2842 3.12005 17.1194 9.40576 16.7567 17.142C16.6359 21.3728 18.2073 25.2409 20.8666 28.0211C22.3172 29.4717 23.0425 31.5266 23.0425 33.4607V38.0541C23.0425 39.7464 24.3721 41.0761 26.0644 41.0761C26.0644 44.3398 28.7238 46.8783 31.8666 46.8783C35.0095 46.8783 37.6688 44.2189 37.6688 41.0761H37.548C39.2403 41.0761 40.5699 39.7464 40.5699 38.0541V33.4607C40.5699 31.4058 41.2952 29.4717 42.6249 28.0211C45.1633 25.3618 46.7348 21.6146 46.7348 17.6255C46.8556 9.04313 39.6029 2.15302 30.8996 2.63653Z"
          fill="#F0CBA7"
        />
        <path
          d="M43.2912 16.0686C43.2912 7.48617 36.0384 0.47518 27.3351 1.07958C19.7197 1.56309 13.5549 7.84881 13.3131 15.4642C13.1923 19.695 14.7637 23.5631 17.423 26.3433C18.8736 27.7939 19.5989 29.8488 19.5989 31.7829V36.3763C19.5989 38.0686 20.9285 39.3983 22.6208 39.3983H34.1044C35.7967 39.3983 37.1263 38.0686 37.1263 36.3763V31.7829C37.1263 29.7279 37.8516 27.7939 39.1813 26.3433C41.7197 23.684 43.2912 20.0576 43.2912 16.0686Z"
          stroke="#EA7200"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.478 33.5959H37.0055"
          stroke="#EA7200"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.423 45.3212C25.1593 45.3212 22.6208 42.6619 22.6208 39.519H34.2252C34.2252 42.6619 31.5659 45.3212 28.423 45.3212Z"
          stroke="#EA7200"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.54396 15.8269H1.46704"
          stroke="#226937"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.20328 9.66202L5.5769 6.03564"
          stroke="#226937"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.20328 22.4751L5.5769 26.1015"
          stroke="#226937"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.4562 15.4644H54.654"
          stroke="#226937"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.7968 9.42032L50.4231 5.79395"
          stroke="#226937"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.7968 22.1125L50.4231 25.7389"
          stroke="#226937"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M43.2912 16.0686C43.2912 7.48617 36.0384 0.47518 27.3351 1.07958C19.7197 1.56309 13.5549 7.84881 13.3131 15.4642C13.1923 19.695 14.7637 23.5631 17.423 26.3433C18.8736 27.7939 19.5989 29.8488 19.5989 31.7829V36.3763C19.5989 38.0686 20.9285 39.3983 22.6208 39.3983H34.1044C35.7967 39.3983 37.1263 38.0686 37.1263 36.3763V31.7829C37.1263 29.7279 37.8516 27.7939 39.1813 26.3433C41.7197 23.684 43.2912 20.0576 43.2912 16.0686Z"
          stroke="#EA7200"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.478 33.5959H37.0055"
          stroke="#EA7200"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.423 45.3212C25.1593 45.3212 22.6208 42.6619 22.6208 39.519H34.2252C34.2252 42.6619 31.5659 45.3212 28.423 45.3212Z"
          stroke="#EA7200"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.0054 16.0685C37.0054 10.8707 32.5329 6.63994 27.2142 6.8817"
          stroke="#226937"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
});
